var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.pdfStyle)},[(_vm.isLoaded)?_c('pdf-viewer',{attrs:{"src":_vm.document.previewSource.source,"should-render-by-plugin-forcibly":_vm.shouldRenderDocumentPdfByPlugin}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }